// appInsights.js
import {
  ApplicationInsights,
  SeverityLevel,
} from '@microsoft/applicationinsights-web';
import authCookie from './api/auth-cookie';

/* eslint no-underscore-dangle: ["error", { "allow": ["__RUNTIME_CONFIG__"] }] */
const appInsightsInstance =
  !window.__RUNTIME_CONFIG__.NODE_ENV ||
  window.__RUNTIME_CONFIG__.NODE_ENV === 'development'
    ? {
        appInsights: Object,
        loadAppInsights: () => ({}),
        trackPageView: () => ({}),
        trackEvent: () => ({}),
        trackException: () => ({}),
      }
    : new ApplicationInsights({
        config: {
          instrumentationKey: `${window.__RUNTIME_CONFIG__.REACT_APP_APPINSIGHTS_INSTRUMENTATIONKEY}`,
          /* ...Other Configuration Options... */
        },
      });

appInsightsInstance.loadAppInsights();

const trackEvent = name => {
  const user = authCookie.getUserData();
  appInsightsInstance.trackEvent({
    name,
    properties: {
      user: user.sub,
      organization: user.orgName,
      organizationId: user.org,
    },
  });
};

const trackException = (error, severity) => {
  const trackedError = new Error(error);
  const user = authCookie.getUserData();

  appInsightsInstance.trackException({
    error: trackedError,
    exception: trackedError,
    severityLevel: severity,
    properties: {
      user: user.sub,
      organization: user.orgName,
      organizationId: user.org,
    },
  });
};

const trackPageView = () => {
  appInsightsInstance.trackPageView();
};

const appInsights = {
  trackEvent,
  trackException,
  trackPageView,
};

export { SeverityLevel };

export default appInsights;
